"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.label = exports.toCode = exports.find = exports.all = void 0;
var langs_1 = __importDefault(require("langs"));
var all = langs_1.default.all().map(function (lang) { return (__assign(__assign({}, lang), { code: lang['2'], label: lang.local, alpha2: lang['1'], alpha3: [lang['2'], lang['2B'], lang['2T'], lang['3']], ietf: lang['ietf'] })); });
exports.all = all;
var find = function (code) {
    return all.find(function (_a) {
        var alpha2 = _a.alpha2, alpha3 = _a.alpha3, ietf = _a.ietf;
        return __spreadArray(__spreadArray([alpha2], alpha3, true), [ietf], false).includes(code);
    });
};
exports.find = find;
var toCode = function (code) {
    var _a;
    var language = find(code);
    return (_a = language === null || language === void 0 ? void 0 : language[2]) !== null && _a !== void 0 ? _a : code;
};
exports.toCode = toCode;
var label = function (code) {
    var _a;
    var language = find(code);
    return (_a = language === null || language === void 0 ? void 0 : language.label) !== null && _a !== void 0 ? _a : code;
};
exports.label = label;
